// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col cols="12" justify-center>
        <v-card>
          <v-card-title class="headline">
            Stats
          </v-card-title>
          <v-card-text>
            <p>Total Orgs: {{ organizations }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'
// import { mapGetters } from 'vuex'
// import {checkPermission} from 'vue-common/components/user'
// import {PERMISSIONS} from 'vue-common/components/constants'

export default {
  data () {
    return {
      organizations: 0
    }
  },

  created () {
    ApiRequests.getOrganizations().then(r => {
      this.organizations = r.data.length
    })
  },

  computed: {
    // ...mapGetters([
    //   'accessRules'
    // ])
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Stats.vue?9b1e1ba6